import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { share, map, tap } from 'rxjs/operators';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';

@Injectable({
	providedIn: 'root'
})
export class LoginLogsService {

	constructor(private http: HttpClient) {
	}

	// **********************************************************************
	// call back-end to get last X logs
	async getLogs(startDate: Date = null, endDate: Date = null) {
		try {
			let url = AppConstants.apiUrl + AppConstants.apiUrls.loginlogs + '?a=b';
			if (startDate && startDate !== null) url += '&startDate=' + encodeURIComponent(startDate + '');
			if (endDate && endDate !== null) url += '&endDate=' + encodeURIComponent(endDate + '');

			const result = await this.http.get<Models.LoginHistory[]>(url).toPromise();
			const arr: Models.LoginHistory[] = result;

			return arr;
		} catch (error: any) {
			MiscTools.handleBackendError(error);
		}
	}


	// **********************************************************************
	// call back-end to get last X logs
	async getLogsForUser(id: number, startDate: Date = null, endDate: Date = null) {
		try {
			let url = AppConstants.apiUrl + AppConstants.apiUrls.loginlogs + '/user/' + id;
			if (startDate && startDate !== null) url += '&startDate=' + encodeURIComponent(startDate + '');
			if (endDate && endDate !== null) url += '&endDate=' + encodeURIComponent(endDate + '');

			const result = await this.http.get<Models.LoginHistory[]>(url).toPromise();
			const arr: Models.LoginHistory[] = result;

			return arr;
		} catch (error: any) {
			MiscTools.handleBackendError(error);
		}
	}

	// **********************************************************************
	// call back-end to get last X logs
	async getLogsOrganization(id: number, startDate: Date = null, endDate: Date = null) {
		try {
			let url = AppConstants.apiUrl + AppConstants.apiUrls.loginlogs + '/organization/' + id;
			if (startDate && startDate !== null) url += '&startDate=' + encodeURIComponent(startDate + '');
			if (endDate && endDate !== null) url += '&endDate=' + encodeURIComponent(endDate + '');

			const result = await this.http.get<Models.LoginHistory[]>(url).toPromise();
			const arr: Models.LoginHistory[] = result;

			return arr;
		} catch (error: any) {
			MiscTools.handleBackendError(error);
		}
	}

	// **********************************************************************
	async getLoginCounts(daysBack: number, success: string) {
		try {
			let url = AppConstants.apiUrl + AppConstants.apiUrls.loginlogs + '/location-counts'
				+ '?daysBack=' + encodeURIComponent(daysBack)
				+ '&success=' + encodeURIComponent(success);
			const result = await this.http.get<any[]>(url).toPromise();
			const arr: any[] = result;
			return arr;
		} catch (error: any) {
			MiscTools.handleBackendError(error);
			return null;
		} // try
	} // getLoginCounts
}
